import { Component, inject } from '@angular/core';
import { HubRecordEditorBase } from '../_hub_record_editor_base';
import { OutcomesEditService } from '../outcomes-edit-container/services/outcomes-edit.service';
import { ErrorService } from '../../../core/services/error.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

enum tabs {
    linkedOutcomes,
    goalTargets,
}

@Component({
  selector: 'app-program-management-outcomes-edit-container',
  templateUrl: './program-management-outcomes-edit-container.component.html',
  styleUrl: './program-management-outcomes-edit-container.component.scss',
  standalone: false
})
export class ProgramManagementOutcomesEditContainerComponent extends HubRecordEditorBase {
    private outcomesEditService: OutcomesEditService = inject(OutcomesEditService);
    private errorService: ErrorService = inject(ErrorService);
    private dialogService: MatDialog = inject(MatDialog);

    public tabs = tabs;
    activeTab: tabs = tabs.linkedOutcomes;

    public setTabTo(tab: tabs, e: Event): void {
        this.activeTab = tab;
        e.preventDefault();
    }
}
